import React from 'react';
import { Dropdown } from 'react-bootstrap';
import DiscoveryTooltip from 'DiscoveryTooltip';
import HelpIcon from 'Utils/HelpIcon';

// Style-guide page header: one block, four slots, fixed order —
// eyebrow / domain icon + title / meta row / actions.
// `header` renders as the page's ONE <h1> (24px, sentence case) so the heading outline starts
// at level 1 on every screen; section headings below it are <h2>.
// Optional slots: `eyebrow` (screen/type name, caps), `meta` (the census sentence — "N sources
// · N discovered · N never discovered" — plus status pills), `primaryAction` (the one
// filled-blue button or funnel for the screen), `help` (one sentence on what the page is for,
// behind a focusable info icon beside the title). The Actions dropdown hides entirely when it
// has no items — never ship a dead control.
function PageHeader({ icon: Icon, header, actions, tooltip, eyebrow, meta, primaryAction, iconVariant, help }) {
  const hasActions = actions && actions.length > 0;
  return (
    <header className='sg-page-header mb-3 mt-3'>
      <div className='sg-page-header__titles'>
        { eyebrow && <div className='sg-eyebrow'>{ eyebrow }</div> }
        <div className='sg-page-header__title-row'>
          { Icon && (
            <DiscoveryTooltip placement='bottom' text={tooltip}>
              <span className={`sg-domain-icon${iconVariant ? ` sg-domain-icon--${iconVariant}` : ''}`}>
                <Icon size='30px' />
              </span>
            </DiscoveryTooltip>
          )}
          <h1 className='sg-title'>{ header }</h1>
          { help && <HelpIcon help={help} placement='right' testId='page-header-help' /> }
        </div>
        { meta && <div className='sg-page-header__meta'>{ meta }</div> }
      </div>
      <div className='sg-page-header__actions'>
        { primaryAction }
        { hasActions && (
          <Dropdown alignRight={true}>
            <Dropdown.Toggle
              data-testid='page-header-actions-toggle'
              size='sm'
              className="pr-4 pl-4"
              variant='outline-secondary'
            >
              Actions
            </Dropdown.Toggle>
            <Dropdown.Menu>
              { actions.map(a => a) }
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </header>
  );
}

export default PageHeader;
